"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.standardDocServerPath = exports.standardOrchestratorDocGenPath = void 0;
exports.standardOrchestratorDocGenPath = "/api/3pq-ot/v1/document-generation";
exports.standardDocServerPath = "/api/3pq-ds/v1";
